import * as React from 'react';
import { PlusSmall, Username } from '../../../../icons';
import { RectangleButton } from '../../../buttons';
import { Text } from '../../../texts';
import { Styled } from '../../styled';

interface Props {
  addUserButtonClick: () => void;
}

export const EmptySeat = React.memo<Props>(({ addUserButtonClick }) => {
  return (
    <Styled.User>
      <Styled.MoreUserAvatar>
        <Username />
      </Styled.MoreUserAvatar>
      <Styled.UserTextInfo>
        <Text>Free seat</Text>
      </Styled.UserTextInfo>
      <Styled.AddUserButton>
        <RectangleButton
          text={'Add user'}
          Icon={PlusSmall}
          mood="secondary"
          height={30}
          iconHeight={10}
          fontSize={12}
          onClick={addUserButtonClick} />
      </Styled.AddUserButton>
    </Styled.User>
  );
});
